<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">注册起始时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.regBeginTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.regEndTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">审核时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.auditBeginTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.auditEndTime"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">车牌号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.carNo"  name="start-date"></span>
				</div>
				
				<div class="order-query-form-box">
					<label for="start-date">身份证号码：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.idCard"  name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">名字：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.name" name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">注册手机号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone" name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">业务员电话：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.salemanPhone"  name="start-date"></span>
				</div>
			<!-- 	<div class="order-query-form-box">
					<label for="start-date">业务员名称：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.salemanName"  name="start-date"></span>
				</div> -->
				
				<div class="order-query-form-box">
					<label for="start-date">是否审核：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.isAudit" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in isAuditList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">用户状态：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.userStatus" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in userStatusList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">是否签约：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.checkSign" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in checkSignDescList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">车型：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.vehicleModel" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in vehicleModelList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">是否提交手写签名：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.signPic" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in signPicState"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
			</div>	
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer"   @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box  deiverMaterialBox">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:showPage="togglePage"
				:loading="loading" 
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
		</div>
		<div class="previewImg" v-if="toggleImg">
			<img @click="toggleImg=false" class="closeImg" src="../../assets/images/close.png" alt="">
			<div class="previewImgWarp">
				<div class="mypreviewImg">
					<img :src="previewPath" >
				</div>
			</div>
		</div>
		
		<st-dialog title="修改司机信息"  :toggleStDialog="toggleStEditDialog" @closeDialog="closeEditForm" @saveDialog="saveEditForm" :setScrollTop="true">
			<div class="st-dialog-content" >
				<ul class="st-dialog-form clearfix">
					<li>
						<div class="st-dialog-item-title"><i>*</i>司机姓名：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="userInfo.name"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>司机电话：</div>
						<div class="st-dialog-item-input"><input type="number" disabled v-model="userInfo.phone" ></div>
					</li>
					
					<li>
						<div class="st-dialog-item-title"><i>*</i>身份证：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="userInfo.idCard" @blur="changeInput('idCard')" ></div>
					</li>
					
					<li>
						<div class="st-dialog-item-title"><i>*</i>车牌号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="userInfo.carNo" @blur="changeInput('carNo')"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>驾驶证：</div>
						<div class="st-dialog-item-input"><input type="text"  v-model="userInfo.driverLicenseNo"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>车辆识别代码：</div>
						<div class="st-dialog-item-input"><input type="text"  v-model="userInfo.vehicleLicenseNo"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>车型：</div>
						<div class="st-dialog-item-input">
							<el-select v-model="userInfo.vehicleModel" placeholder="请选择" class="stSetSelect" >
								<el-option
								v-for="item in modelList"
								:key="item"
								:label="item"
								:value="item">
								</el-option>
							</el-select>
						</div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>车长（m）：</div>
						<div class="st-dialog-item-input"><input type="text"    v-model="userInfo.vehicleLength" @input="numberInput($event,'userInfo','vehicleLength',2)" ></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>车宽（m）：</div>
						<div class="st-dialog-item-input"><input type="text"    v-model="userInfo.vehicleWidth"  @input="numberInput($event,'userInfo','vehicleWidth',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>车高（m）：</div>
						<div class="st-dialog-item-input"><input type="text"    v-model="userInfo.vehicleHeight"  @input="numberInput($event,'userInfo','vehicleHeight',2)"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>是否自带尾板：</div>
						<div class="st-dialog-item-input">
							<el-select v-model="userInfo.hasLiftGate" placeholder="请选择" class="stSetSelect" >
								<el-option
								v-for="item in hasLiftGateList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
					</li>
					<li>
						<div style="height:50px"></div>
					</li>
					<li>
						<div class="st-dialog-item-title">车头照：</div>
						<div class="upFileWrap" ref="testPic">
							<input type="file"  @change="changeImage(userInfo,'carHeadUrl')" ref="carHeadUrl" />
							<img :src="userInfo.carHeadUrl"  v-if="userInfo.carHeadUrl">
							<img src="../../../src/assets/images/add.png" v-else >
						</div>
					</li>
					<li>
						<div class="st-dialog-item-title">驾驶证：</div>
						<div class="upFileWrap" ref="testPic">
							<input type="file"  @change="changeImage(userInfo,'driverLicenseUrl')" ref="driverLicenseUrl" />
							<img :src="userInfo.driverLicenseUrl"  v-if="userInfo.driverLicenseUrl">
							<img src="../../../src/assets/images/add.png" v-else >
						</div>
					</li>
					<li>
						<div class="st-dialog-item-title">行驶证</div>
						<div class="upFileWrap" ref="testPic">
							<input type="file"  @change="changeImage(userInfo,'vehicleLicenseUrl')" ref="vehicleLicenseUrl" />
							<img :src="userInfo.vehicleLicenseUrl"  v-if="userInfo.vehicleLicenseUrl">
							<img src="../../../src/assets/images/add.png" v-else >
						</div>
					</li>
					<li>
						<div class="st-dialog-item-title">身份证：</div>
						<div class="upFileWrap" ref="testPic">
							<input type="file"  @change="changeImage(userInfo,'idCardFrontUrl')" ref="idCardFrontUrl" />
							<img :src="userInfo.idCardFrontUrl"  v-if="userInfo.idCardFrontUrl">
							<img src="../../../src/assets/images/add.png" v-else >
						</div>
					</li>
					<li>
						<div class="st-dialog-item-title">身份证（反面）：</div>
						<div class="upFileWrap" ref="testPic">
							<input type="file"  @change="changeImage(userInfo,'idCardBackUrl')" ref="idCardBackUrl" />
							<img :src="userInfo.idCardBackUrl"  v-if="userInfo.idCardBackUrl">
							<img src="../../../src/assets/images/add.png" v-else >
						</div>
					</li>
					<li>
						<div class="st-dialog-item-title">手持身份证：</div>
						<div class="upFileWrap" ref="testPic">
							<input type="file"  @change="changeImage(userInfo,'holdIdCardUrl')" ref="holdIdCardUrl" />
							<img :src="userInfo.holdIdCardUrl"  v-if="userInfo.holdIdCardUrl">
							<img src="../../../src/assets/images/add.png" v-else >
						</div>
					</li>
				</ul>
			</div>
		</st-dialog>
		<st-dialog :title="dialogTitle" :toggleStDialog="toggleStDialog" @closeDialog="toggleStDialog=false"
			@saveDialog="saveDialogForm" >
			<div class="st-dialog-content" >
				<ul class="upFileBox clearfix">
					<li>
						<p>手写签名</p>
						<div class="upFileWrap" ref="testPic">
							<input type="file"  @change="changeImage(signDate,'signPic')" ref="signPic" />
							<img :src="signDate.signPic"  v-if="signDate.signPic">
							<img src="../../../src/assets/images/add.png" v-else >
						</div>
					</li>
					<li>
						<p>电子合同</p>
						<div class="upFileWrap">
							<input type="file"  @change="changeImage(signDate,'signContractPic')" ref="signContractPic" />
							<img :src="signDate.signContractPic" v-if="signDate.signContractPic">
							<img src="../../../src/assets/images/add.png" v-else >
						</div>
					</li>
				</ul>
			</div>
		</st-dialog>
	</div>
</template>
<script>
import stDialog from '../../components/StDialog'
const unbindList = []
export default {
	name: 'DriverMaterial',
	props: [],
	components: { stDialog },
	data(){
		return{
			toggleStDialog:false,
			toggleStEditDialog:false,
			
			dialogTitle:'上传合同',
			tableColumns:[
				{
					title: '选择',
					type: 'selection',
					fixed: 'left',
				},{
					key: '',
					title: '操作',
					operate:true,
					align:'center',
					width: '180',
					setBtns:(row,index)=>{
						return [
							{
								label:'修改',
								handler: (row,index) => this.editUser(row)
							},
							{ 
								label:'上传合同',
								handler: (row,index) => this.editContract(row)
							},
							{ 
								label:'上传身份资料',
								handler: (row,index) => this.uploadIdentity(row)
							},
							{
								label:'签约',
								handler: (row,index) => this.signUp(row)
							},
							
						]
					}
				},
				
				
				{key: 'regTimeFormatted',width: '150',title: '注册时间'},
				{key: 'auditStateDesc',width: '100',title: '是否审核'},
				{key: 'userStatusDesc',width: '90',title: '状态'},
				{key: 'reviewerDesc',width: '100',title: '审核人'},
				{key: 'name',width: '150',title: '司机姓名'},
				{key: 'phone',width: '198',title: '司机电话'},
				{key: 'idCard',width: '198',title: '身份证号'},
				{key: 'salemanName',title: '业务员名称'},
				{key: 'salemanPhone',title: '业务员手机号'},
				{key: 'auditTimeFormatted',width: '150',title: '审核时间'},
				{key: 'carNo',width: '100',title: '车牌号'},
				{key: 'vehicleModel',width: '100',title: '车型'},
				{
					key:'checkSignDesc',
					width:'80',
					align:'center',
					title:'是否签约'
				},
				{
					title: '车头照',
					width: '100',
					align:'center',
					imgProps:'carHeadUrl',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},
				{title: '驾驶证',width: '100',
					align:'center',
					imgProps:'driverLicenseUrl',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},
				{title: '车辆识别代码',width: '100',
				align:'center',
					imgProps:'vehicleLicenseUrl',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},
				{title: '身份证',width: '100',
				align:'center',
					imgProps:'idCardFrontUrl',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},
				{title: '身份证反面',width: '100',
				align:'center',
					imgProps:'idCardBackUrl',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},
				{title: '手持身份证',width: '100',
				align:'center',
					imgProps:'holdIdCardUrl',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},
				{title: '手写签名',width: '100',
				align:'center',
					imgProps:'signPic',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},
				{title: '电子合同',width: '100',
				align:'center',
					imgProps:'signContractPic',
					viewImg:true,
					handler: (row) => this.argImg(row)
				},				
			],
			
			loading: false,
			pageConfig: {
				total: 0,
				pageSize: 50,
				currentPage: 1,
			},
			bottomHandleArr: [
				{
					label: '解冻',
					handler: () => this.freezeUser(1)
				},{
					label: '冻结',
					type: 'success',
					handler: () => this.freezeUser(2)
				},{
					label: '审核通过',
					type: 'success',
					handler: () => this.setAudit()
				},{
					label: '审核拒绝',
					handler: () => this.setAuditRefuse()
				},
				{
					label: '导出',
					type: 'success',
					handler: () => this.exportTable()
				},{
					label: '批量审核',
					type: 'success',
					handler: () => this.setAudit()
				},
				{
					label: '解绑业务员',
					handler: () => this.unbind()
				},
			],

			toggleImg:false,
			previewPath:null,
			dataList:[], //订单列表
			orderForm:{
				carNo: null, //	车牌号	string	
				idCard: null, //	身份证号码	string	
				isAudit: null, //	是否审核：0=未通过、1=已通过、null=全部	number	
				name: null, //	名字	string	
				phone: null, //	注册手机号	string	
				regBeginTime: null, //	注册起始时间	string	格式：yyyy-MM-dd HH:mm:ss
				regEndTime: null, //	注册结束时间	string	格式：yyyy-MM-dd HH:mm:ss
				userStatus: '', //	用户状态 1=正常 2=冻结 3=注销	number	
				userType: 2, //	用户类型 1=货主 2=司机	string	
				checkSign:'' ,//是否签约 0/未签约 1/已签约 2/等待确认 3/被拒绝
				vehicleModel:'',
				signPic:''
			},
			togglePage:false, //是否显示分页
			selDriverId:null, //选中的司机
			selectedList:[],// 选中的列表
			driverList:[],// 司机列表
			isAuditList:[{
					value: null,
					label: '全部'
				},{
					value: 0,
					label: '未通过'
				}, {
					value: 1,
					label: '已通过'
				}, {
					value: 3,
					label: '审核中'
				}],
			userStatusList:[
				{
					value: '',
					label: '全部'
				},
				{
					value: 1,
					label: '正常'
				}, {
					value: 2,
					label: '冻结'
				}, {
					value: 3,
					label: '注销'
			}],
			checkSignDescList:[
				{
					value: '',
					label: '全部'
				},
				{
					value: 0,
					label: '未签约'
				}, {
					value: 1,
					label: '已签约'
				}, {
					value: 2,
					label: '等待确认'
				}, {
					value: 3,
					label: '被拒绝'
				}],
			vehicleModelList:[
				{
					value: '',
					label: '全部'
				}
			],
			hasLiftGateList:[
				{
					value: false,
					label: '无'
				},{
					value: true,
					label: '有'
				}
			],
			signPicState:[
				{
					value: '',
					label: '全部'
				},
				{
					value: 1,
					label: '已提交'
				}, {
					value: 0,
					label: '未提交'
				}],
			modelList:[],
			signDate:{
				signPic:'',// 手写合同
				signContractPic:'',//电子合同
				id:'',
			},
			userInfo:{},
			checkData:{
				name:'司机姓名不可为空',
				idCard:'身份证号不可为空',
				carNo:'车牌号不可为空',
				driverLicenseNo:'驾驶证不可为空',
				vehicleLicenseNo:'车辆识别代码不可为空',
			}
		}
	},
	created() {
		this.getCars()
	},
	methods: {
		changeInput(key){
			if(!this.userInfo[key]) return;
			if(key==='carNo'){
				this.userInfo[key]=this.userInfo[key].toUpperCase()
			}else if(key==='idCard'){
				let reg=/^[0-9][0-9]{16}[0-9|x]$/i
				if(!reg.test(this.userInfo[key])){
					this.$toast.stMessage('身份证号格式不正确', false)
				}
			}
		},
		editUser(row){
			this.userInfo=JSON.parse(JSON.stringify(row));
			this.toggleStEditDialog=true
		},
		saveEditForm(){
			for(var key in this.checkData){
				if(!this.userInfo[key]){
					this.$toast.stMessage(this.checkData[key], false)
					return;
				}
			}
			this.$server.material.updateMiniUser(this.userInfo,(res)=>{
				if(res.code==0){
					this.$toast.stMessage('修改成功', true)
					this.searchList()
					this.toggleStEditDialog=false;
				}
			})
		},
		closeEditForm(){
			this.toggleStEditDialog=false
		},
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},

		currentChange(currentPage) {
			this.pageConfig.currentPage = currentPage
			this.searchList()
		},
		freezeUser(flag) {
			if(this.selectedList.length != 1){
				this.$toast.stMessage('请选择一个用户',true)
				return;
			}
			// 冻结
			this.$server.material.freezeUser({
				id: this.selectedList[0].id,
				userStatus: flag
			},(res)=>{
				this.$toast.stMessage(flag==1?'解冻成功':'冻结成功',true)
				this.searchList();
			})
			
		},
		//解绑业务员
		unbind() {
			
			console.log(this.selectedList)
			if(this.selectedList.length <1){
				this.$toast.stMessage('请至少选择一个用户',true)
				return;
			}else{
				for(var i = 0;i <this.selectedList.length;i++){
					unbindList.push(this.selectedList[i].id)
				}
				console.log(unbindList)
				// 解绑
				this.$server.material.unbind({
					id: unbindList,
				},(res)=>{
					if (res.code == 0) {
					this.$toast.stMessage('解绑成功', true)
					this.searchList()
					unbindList.length =0
					}
				})
			}
			
			
		},
		argImg(src){
			this.previewPath=src;
			this.toggleImg=true;
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			this.loading=true;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		
		getData(data){
			this.$server.material.stPage(data,(res)=>{
				this.loading=false;
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}
			})
		},
		getCars(){
			this.$server.system.getAllCar({},res=>{
				let vehicleModelList=res.data.map(item=>{
					return {
						value: item,
						label: item
					}
				})
				this.modelList=res.data;
				this.vehicleModelList=[...this.vehicleModelList,...vehicleModelList]
			})
		},
		// 审核
		setAudit(){
			let that=this;
			if(this.selectedList.length<1){
				that.$toast.stMessage('请选择司机',true)
				return;
			}
			let listId=[];
			if(this.selectedList.length>0){
				this.selectedList.forEach(item => {
					listId.push(item.id)
				});
			}
			this.$server.material.auditCheck(listId,(res)=>{
				if(res.code==0){
					that.$toast.stMessage('审核通过',true)
					that.searchList();
				}else{
					that.$toast.stMessage(res.message,false)
				}
			})
		},

		setAuditRefuse() {
			let that=this;
			if(this.selectedList.length<1){
				that.$toast.stMessage('请选择订单',true)
				return;
			}
			let listId=[];
			if(this.selectedList.length>0){
				this.selectedList.forEach(item => {
					listId.push(item.id)
				});
			}
			this.$server.material.auditUnCheck(listId,(res)=>{
				if(res.code==0){
					that.$toast.stMessage('拒绝成功',true)
					that.searchList();
				}else{
					that.$toast.stMessage(res.message,false)
				}
			})
		},
		selectionChange(row){
			this.selectedList=row;

		},
		// 导出
		exportTable(){
			let that = this;
			if (this.dataList.length<1) {
				that.$toast.stMessage('暂无数据', true)
				return;
			}
			let pages = {};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			const sendData = {
				...this.orderForm,
				exportColumnFiledNames: this.tableColumns.map((item) =>{
					return item.key || item.imgProps || item.checkSignDesc
				}).filter(item => {
					return item && item.trim()
				})
			}
			sendData.createTimeBegin = sendData.createTimeBegin ? new Date(sendData.createTimeBegin).getTime() : ''
			sendData.createTimeEnd = sendData.createTimeEnd ? new Date(sendData.createTimeEnd).getTime() : ''
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/appuser/driverInformationExport',sendData, (res) => {
				console.log('导出成功')
			})
		},
        //上传身份资料
		uploadIdentity(row){
			console.log(row)
			let identityData = {
				id: row.id
			}
            this.$server.material.payUploadIdcard(identityData,(res)=>{
			if(res.code !== 0){
				this.$toast.stMessage(res.message,false)
			}else{
					this.$toast.stMessage('上传成功!', true)
					this.getCars()
				}
			})
		},
		editContract(row){
			for(let key in this.signDate){
				this.signDate[key]=row[key]
			}
			this.toggleStDialog=true;
			setTimeout(() => {
				this.compressedPicture()
			}, 2000);
		},
		saveDialogForm(){
			this.toggleStDialog=false;
			this.$server.material.saveShuiDaShiImg(this.signDate,(res)=>{
				if(res.code==0){
					this.searchList();
					that.$toast.stMessage('保存成功',false)
				}else{
					that.$toast.stMessage(res.message,false)
				}
			})
		},

		changeImage(obj,el){
				console.log( this.$refs[el])
			var files = this.$refs[el].files;
			console.log(files)
			let formData = new FormData()
			formData.append('file', files[0])
			this.$server.material.upFile(formData,(res)=>{
				obj[el]=res.data.url
			})
		},
		compressedPicture ( ) {
			var canvas = document.createElement('canvas'); 
			var ctx = canvas.getContext('2d'); 
			var img = this.$refs.testPic;
			img.onload = function(){
				console.log(img.width);
				var width = img.width;
				var height = img.height;
				// 按比例压缩4倍
				var rate = (width < height ? width / height : height / width) / 4;
				canvas.width = width * rate; 
				canvas.height = height * rate; 
				ctx.drawImage(img, 0, 0, width, height, 0, 0, width * rate, height * rate); 
				var dataURL = canvas.toDataURL('image/jpeg'); 
				canvas = null; 
				console.log(dataURL);
			};
			// img.src = url
		},
		signUp(row){
			let data={}
			data.id=row.id;
			this.$server.material.shuiDShiSignUp(data,(res)=>{
				if(res.code==0){
					this.searchList();
					this.$toast.stMessage('签约成功',true)
				}else{
					this.$toast.stMessage('签约失败',false)
				}
			})
		},
		numberInput(e,obj,attr,n){
			var inputValue=e.target.value;
			inputValue=this.$util.numDotCovt(inputValue,n);
			this[obj][attr]=inputValue 
		},
	},
	mounted() {
		
	}
}

</script>
<style scoped>
.st-main-content{
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
}
.data-table-box {
    height: auto;
    background: #FFF;
    padding: 8px;
    box-sizing: border-box;
}	
.data-table{
	margin-bottom: 8px;
}
.query-setting-box-left{
    flex-grow: 0;
}
.previewImg{
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background-color: rgba(0, 0, 0, .5);
	z-index: 99;
}
.previewImgWarp{
	position: absolute;
	left: 50%;
	top: 50%;
	margin-left: -300px;
	margin-top: -300px;
	width: 600px;
	height: 600px;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: auto;
}
.mypreviewImg{
	display: inline-block;
	border: 5px solid #fff;
	border-radius: 3px;
	overflow: hidden;
}
.mypreviewImg img{
	max-width: 580px;
	/* width: 530px;
	height: 1500px; */
}
.closeImg{
	position: absolute;
	top: 20px;
	right: 20px;
	cursor: pointer;
}
.stMbgc.success {
	background-color: seagreen;
}
.upFileBox {
	display: flex;
	justify-content:center;
	padding:20px 0;
}
.upFileBox li{
	width: 150px;
	margin: 0 5px;
}
.upFileBox li p{
	text-align: center;
}
.upFileBox li .upFileWrap,.st-dialog-form li .upFileWrap {
	cursor: pointer;
	margin-top: 5px;
	position: relative;
	width: 150px;
	height: 150px;
	border: 1px solid #ccc;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
}
.upFileBox li .upFileWrap input,.st-dialog-form li .upFileWrap input {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	outline: none;
	border: none;
	opacity: 0;
}
.upFileBox li .upFileWrap img , .st-dialog-form li .upFileWrap img{
	max-width: 100%;
	max-height: 100%;
}

.st-dialog-content{
	padding: 0 32px;
}
.st-dialog-form{
	width: 406px;
}
.st-dialog-form li {
	width: 156px;
	padding: 13px 0;
}
.st-dialog-form li:nth-child(even){
	float: right;
}
.st-dialog-form li:nth-child(odd){
	float: left;
}
.st-dialog-form .st-dialog-item-title{
	height: 20px;
	line-height: 20px;
}
.st-dialog-form .st-dialog-item-title i{
	color: #FF5B3E;
}
.st-dialog-form .st-dialog-item-input input{ 
	width: 156px;
	height: 30px;
	text-indent: 8px;
	border-radius: 2px;
	border: 1px solid #DCDCDC;
	box-sizing: border-box;
}
</style>
